/**
 * Client entry point
 */

require("core-js/stable");
require("regenerator-runtime/runtime");

import React from 'react';
import ReactDOM, { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import App from './App';
import { configureStore } from './store';
import ErrorBoundary from './components/Error/ErrorBoundary';

import { AsyncComponentProvider, createAsyncContext } from 'react-async-component'; // 👈
import asyncBootstrapper from 'react-async-bootstrapper'; // 👈


// PWA Offline support: https://github.com/NekR/offline-plugin
import * as OfflinePluginRuntime from 'offline-plugin/runtime';
OfflinePluginRuntime.install();


// Initialize store
const store = configureStore(window.__INITIAL_STATE__);
const mountApp = document.getElementById('root');

// Block react-intl errors
if(process.env.NODE_ENV !== 'production') {
    const originalConsoleError = console.error
    if (console.error === originalConsoleError) {
        console.error = (...args) => {
            if(`${args[0]}`.indexOf('[React Intl]') === 0) {
                return
            }
            originalConsoleError.call(console, ...args)
        }
    }
}


// Handle async components
// 👇 Get any "rehydrate" state sent back by the server
const rehydrateState = window.ASYNC_COMPONENTS_STATE;

const app = (
    <AsyncComponentProvider rehydrateState={rehydrateState}>
        <App store={store} />
    </AsyncComponentProvider>
);

//   We run the bootstrapper again, which in this context will
//   ensure that all components specified by the rehydrateState
// 👇 will be resolved prior to render.
asyncBootstrapper(app).then(() => {
  // 👇 Render the app
    render(
        <AppContainer key={Math.random()}>
            <ErrorBoundary>
                <Provider store={store}>
                    {app}
                </Provider>
            </ErrorBoundary>
        </AppContainer>
        , mountApp
    );

    // For hot reloading of react components
    if(module.hot) {
        module.hot.accept('./App', () => {
            // If you use Webpack 2 in ES modules mode, you can
            // use <App /> here rather than require() a <NextApp />.
            const NextApp = require('./App').default; // eslint-disable-line global-require
            render(
                <AppContainer key={Math.random()}>
                    <ErrorBoundary>
                        <Provider store={store}>
                            <NextApp store={store} />
                        </Provider>
                    </ErrorBoundary>
                </AppContainer>,
                mountApp
            );
        });
    }
})
